import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useReducer, forwardRef, useImperativeHandle } from 'react';
import { Label, Error, Loading } from 'module-tsl-ui-elements';
import { getClassNames } from 'module-tsl-ui-jobs-common';
import { LocationAutosuggest } from './LocationAutosuggest';
import { LocationPicker } from './LocationPicker';
export var LocationInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var self = _ref.self,
      label = _ref.label,
      input = _ref.input;
  var disabled = self.disabled,
      displayLocationPicker = self.displayLocationPicker,
      inverse = self.inverse,
      _self$groupId = self.groupId,
      groupId = _self$groupId === void 0 ? 'default-location-input-id' : _self$groupId,
      _self$minQueryLength = self.minQueryLength,
      minQueryLength = _self$minQueryLength === void 0 ? 3 : _self$minQueryLength,
      _self$maxSuggestions = self.maxSuggestions,
      maxSuggestions = _self$maxSuggestions === void 0 ? 5 : _self$maxSuggestions,
      _self$size = self.size,
      size = _self$size === void 0 ? 'md' : _self$size,
      _self$throttleTimeout = self.throttleTimeout,
      throttleTimeout = _self$throttleTimeout === void 0 ? 500 : _self$throttleTimeout,
      siteCountry = self.siteCountry;
  var autoFocus = input.autoFocus,
      _input$defaultValue = input.defaultValue,
      defaultValue = _input$defaultValue === void 0 ? '' : _input$defaultValue,
      _input$placeholder = input.placeholder,
      placeholder = _input$placeholder === void 0 ? '' : _input$placeholder,
      mapsApiKey = input.mapsApiKey,
      onLocationChange = input.onLocationChange,
      includedTowns = input.includedTowns;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      details = _useState2[0],
      setDetails = _useState2[1];

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      hasLocation = _useState6[0],
      setHasLocation = _useState6[1];

  var initialState = {
    active: false,
    error: '',
    loading: false,
    suggestions: []
  };

  var _useReducer = useReducer(function (prevState, action) {
    switch (action.type) {
      case 'active':
        return _objectSpread(_objectSpread({}, prevState), {}, {
          active: action.active
        });

      case 'error':
        return _objectSpread(_objectSpread({}, prevState), {}, {
          error: action.error
        });

      case 'loading':
        return _objectSpread(_objectSpread({}, prevState), {}, {
          loading: action.loading
        });

      case 'suggestions':
        return _objectSpread(_objectSpread({}, prevState), {}, {
          suggestions: action.suggestions
        });

      default:
        return prevState;
    }
  }, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var wrapperClasses = ['tds-form__group', self.classNames].join(' ').trim();
  var hasError = state.error && value.length >= 1;
  var inputClasses = getClassNames({
    'tds-control': true,
    'tds-control--inverse': inverse,
    'tds-control--has-error': hasError,
    'tds-control--is-disabled': self.disabled,
    'tds-control--sm': input.size ? input.size === 'sm' : size === 'sm',
    'tds-control--lg': input.size ? input.size === 'lg' : size === 'lg'
  }, input.classNames); // React Autosuggest requires onchange to pass in a very specific 'newValue' parameter
  // see docs https://github.com/moroshko/react-autosuggest#inputpropsonchange-required
  // but we need the rest of the information about the item for the external onLocationChange
  // to use in AlertFilters 🤯

  var onChange = function onChange(e, _ref2, items) {
    var newValue = _ref2.newValue;
    setValue(newValue);
    setDetails(_objectSpread({}, items));
    dispatch({
      type: 'loading',
      loading: Boolean(state.error && newValue)
    });

    if (!hasError || newValue !== value) {
      dispatch({
        type: 'error',
        error: ''
      });
    }

    onLocationChange(newValue, items);
  };

  var handleLocationValues = function handleLocationValues(event, items) {
    onChange(event, {
      newValue: items.value
    }, items);
    dispatch({
      type: 'loading',
      loading: false
    });
    setHasLocation(items && Boolean(items.location));
  };

  var resetLocation = function resetLocation(newLocation) {
    setValue(newLocation);
    setDetails({});
  }; // Adding an ability to change value from outside Autosuggest https://reactjs.org/docs/hooks-reference.html#useimperativehandle


  useImperativeHandle(ref, function () {
    return {
      resetLocation: resetLocation,
      handleLocationValues: handleLocationValues,
      value: value
    };
  });
  var inputDetails = {
    autoFocus: autoFocus,
    className: inputClasses,
    disabled: disabled,
    onChange: onChange,
    placeholder: placeholder,
    id: groupId,
    value: value
  };
  var pickerProps = {
    mapsApiKey: mapsApiKey,
    handleLocationValues: handleLocationValues,
    dispatch: dispatch
  };

  var Towns = function Towns(_ref3) {
    var suggestions = _ref3.suggestions;
    var shouldRenderLocationSelect = includedTowns && value && hasLocation && !suggestions && typeof document !== 'undefined' && !document.getElementById("".concat(groupId)).classList.contains('focus-visible') && !document.getElementById('location-picker');
    return /*#__PURE__*/React.createElement("div", null, shouldRenderLocationSelect && includedTowns);
  };

  var SuggestionsContainer = function SuggestionsContainer(_ref4) {
    var containerProps = _ref4.containerProps,
        children = _ref4.children,
        query = _ref4.query;
    var shouldShowPicker = Boolean(!state.error) && state.active && query && displayLocationPicker;
    var shouldShowExtraLocals = Boolean(includedTowns);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", containerProps, shouldShowPicker &&
    /*#__PURE__*/

    /* 
    react-autosuggest does not render the container unless there are children (or suggestions)
    but it does render this component, so we style it to mimick the container if there are
    no results/children, and remove the container styling if there are any results/children
    */
    React.createElement(LocationPicker, _extends({}, pickerProps, {
      customClass: !children ? 'tds-location-picker__standalone' : ''
    })), children), shouldShowExtraLocals && /*#__PURE__*/React.createElement(Towns, {
      suggestions: children
    }));
  };

  var HiddenInputs = function HiddenInputs() {
    var coordinates = details.coordinates,
        bbox = details.bbox,
        location = details.location;
    return /*#__PURE__*/React.createElement(React.Fragment, null, location && /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "locations",
      value: location,
      className: "location-input"
    }), value && /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "displayLocation",
      value: value,
      className: "location-input"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "bbox",
      value: bbox,
      className: "location-input",
      disabled: !bbox
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "point",
      value: coordinates,
      className: "location-input",
      disabled: !coordinates
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(HiddenInputs, null), label && /*#__PURE__*/React.createElement("div", {
    className: "tds-location-input__label-wrapper"
  }, /*#__PURE__*/React.createElement(Label, _extends({
    size: label.size || size,
    inverse: inverse,
    emphasis: label.emphasis,
    htmlFor: groupId,
    disabled: disabled
  }, label)), state.loading && /*#__PURE__*/React.createElement(Loading, {
    theme: inverse ? 'inverse' : 'primary'
  })), /*#__PURE__*/React.createElement(LocationAutosuggest, {
    inputDetails: inputDetails,
    handleLocationValues: handleLocationValues,
    maxSuggestions: maxSuggestions,
    minQueryLength: minQueryLength,
    throttleTimeout: throttleTimeout,
    SuggestionsContainer: SuggestionsContainer,
    dispatch: dispatch,
    suggestions: state.suggestions,
    siteCountry: siteCountry
  }), hasError && /*#__PURE__*/React.createElement(Error, {
    classNames: "tds-location-autosuggest__error",
    error: state.error
  }));
});